const removeNode = (data) => data.map(item => ({
  // different graphql queries provide the data with or without a .node parent
  ...((item.node) ? item.node : item)
}));

export default removeNode;
